import PartySocket from 'partysocket'
import { getBackendBase } from './backend-url'

const getPartykitHost = () => {
  if (import.meta.env.VITE_PARTYKIT_HOST) return import.meta.env.VITE_PARTYKIT_HOST

  const base = getBackendBase()
  if (base) {
    // If it's an absolute URL, strip the protocol
    return base.replace(/^https?:\/\//, '')
  }

  // Default to current host
  return typeof window !== 'undefined' ? window.location.host : 'localhost:8787'
}

const PARTYKIT_HOST = getPartykitHost()

// TODO: specific room ID per project. For MVP, we might hardcode or get from URL/store.
// We'll export a function to get/create socket for a specific room.

let socketInstance = null

export const getSocket = (projectId = 'home', authToken = '') => {
  if (socketInstance) return socketInstance
  if (!authToken) return null

  socketInstance = new PartySocket({
    host: PARTYKIT_HOST,
    room: projectId,
    party: 'task-room',
    query: {
      token: authToken,
    },
  })

  return socketInstance
}

export const connectToRoom = (projectId, authToken) => {
  const socket = getSocket(projectId, authToken)
  return socket
}
